import { computed } from 'vue'
import { useStore } from 'vuex'

// Hex -> "r, g, b" string for use inside rgb()/rgba() CSS custom properties.
function hexToRgb(hex) {
  if (!hex || typeof hex !== 'string' || hex.length < 7 || !hex.startsWith('#')) {
    return '255, 153, 0'
  }
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) {
    return '255, 153, 0'
  }
  return `${r}, ${g}, ${b}`
}

function shade(hex, percent) {
  if (!hex || typeof hex !== 'string' || hex.length < 7 || !hex.startsWith('#')) {
    return hex
  }
  const target = percent < 0 ? 0 : 255
  const ratio = Math.abs(percent) / 100
  const mix = channel => {
    const value = Math.round((target - channel) * ratio) + channel
    return value.toString(16).padStart(2, '0')
  }
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) {
    return hex
  }
  return `#${mix(r)}${mix(g)}${mix(b)}`
}

/**
 * fr-* design tokens for the Daily Giveaway pass shell, translated from the
 * Lovable source's Tailwind fr-* palette.
 *
 * Sponsor/brand colors (Amazon #FF9900 / #232F3E) are approved branding and are
 * the ONLY place custom hex enters — everything else uses these CSS custom
 * properties so no raw hex is scattered through templates (Padmanaban rule 3).
 *
 * Returned as an inline-style object so it can be bound to the shell root AND to
 * every teleported overlay card (v-dialog/v-bottom-sheet) — CSS custom
 * properties don't cascade into Vuetify overlays, which render outside the shell.
 */
export function useFrTokens() {
  const store = useStore()
  const colors = computed(() => store.getters['giveaway/colors'])

  return computed(() => ({
    '--fr-primary': colors.value.primary,
    '--fr-primary-rgb': hexToRgb(colors.value.primary),
    '--fr-primary-foreground': '#ffffff',
    '--fr-primary-light': shade(colors.value.primary, 25),
    '--fr-primary-deep': shade(colors.value.primary, -12),
    '--fr-accent': colors.value.accent,
    '--fr-accent-rgb': hexToRgb(colors.value.accent),
    '--fr-bg': '#f6f4ef',
    '--fr-surface': '#ffffff',
    '--fr-ink': '#1c1c1e',
    '--fr-ink-rgb': '28, 28, 30',
    '--fr-muted': '#6b7280',
    '--fr-font-serif-display': "'Georgia', 'Times New Roman', serif",
    '--fr-font-display': 'inherit'
  }))
}
